<div [ngClass]="[fullPage ? 'loading-container-full' : 'loading-container-inline', customClass]">
  <mat-spinner class="loading-spinner" [diameter]="diameter"></mat-spinner>
  <span class="loading-text" *ngIf="loadingText">{{ loadingText }}</span>
</div>